import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import { connect } from "react-redux";
import { setStep, setInfo, setFinance, setDoc, setLatest, setCurrent } from "../../store/actions/FormAction";

import '../../css/progressbar.css';

const NavLink = props => (
  <li>
    <Link {...props} />
  </li>
);

class ProgressBar extends Component {
  constructor(){
    super();
    this.handleProgressClick = this.handleProgressClick.bind(this);
  }

  handleProgressClick(e){
    if (e.target.className.includes("pullup")){
      if (e.target.parentNode.className.includes("disabled")){
        e.preventDefault();
      } else {
        this.props.setStep(0);
        this.props.setInfo(0);
        this.props.setFinance(0);
        this.props.setDoc(0);
      }
    } else {
      if (e.target.className.includes("disabled")){
        e.preventDefault();
      } else {
        this.props.setStep(0);
        this.props.setInfo(0);
        this.props.setFinance(0);
        this.props.setDoc(0);
      }
    }
  }

  render() {
      let link1 = "/createpassword";
      let link2 = "/personalinfo";
      let link3 = "/employmentinfo";
      let link4 = "/loandoc1";
      let link5 = "/laststep";
      let linkStyle1 = "firstlink active";
      let linkStyle2 = "disabled";
      let linkStyle3 = "disabled";
      let linkStyle4 = "disabled";
      let linkStyle5 = "disabled";
      let circleStyle2 = "progresscircle disabled";
      let circleStyle3 = "progresscircle disabled";
      let circleStyle4 = "progresscircle disabled";
      let circleStyle5 = "progresscircle disabled";

      if (this.props.loggedin)
        link1 = "/";
      if (this.props.lateststep <= 1){
        link2 = "#";
        link3 = "#";
        link4 = "#";
        link5 = "#";
      } else if (this.props.lateststep <= 4){
        linkStyle2 = "active";
        circleStyle2 = "progresscircle progresscircle2";
        link3 = "#";
        link4 = "#";
        link5 = "#";
      } else if (this.props.lateststep <= 8){
        linkStyle2 = "active";
        circleStyle2 = "progresscircle progresscircle2";
        linkStyle3 = "active";
        circleStyle3 = "progresscircle progresscircle3";
        link4 = "#";
        link5 = "#";
      } else if (this.props.lateststep < 15){
        linkStyle2 = "active";
        circleStyle2 = "progresscircle progresscircle2";
        linkStyle3 = "active";
        circleStyle3 = "progresscircle progresscircle3";
        linkStyle4 = "active";
        circleStyle4 = "progresscircle progresscircle4";
        link5 = "#";
      } else if (this.props.lateststep >= 15){
          linkStyle2 = "active";
          circleStyle2 = "progresscircle progresscircle2";
          linkStyle3 = "active";
          circleStyle3 = "progresscircle progresscircle3";
          linkStyle4 = "active";
          circleStyle4 = "progresscircle progresscircle4";
          linkStyle5 = "activehollow";
          circleStyle5 = "progresscircle progresscircle5";
      }

      if (this.props.notserved){
        link1 = "/noservice";
        link2 = "/noservice";
        link3 = "/noservice";
        link4 = "/noservice";
        link5 = "/noservice";
      } else if (this.props.tooyoung){
        link1 = "/notapproved";
        link2 = "/notapproved";
        link3 = "/notapproved";
        link4 = "/notapproved";
        link5 = "/notapproved";
      }

      // Hard coded progress bar (need to be able add more steps easier)
      // TODO need to set max Loan Docs dynamically (right now manually set to 4)
      if (this.props.step === 0){ //Create account step
        linkStyle1 = "firstlink activehollow";
      } else if (this.props.lateststep === 2){ //Info step
        linkStyle2 = "activehollow";
      } else if (this.props.lateststep === 5){ //Finance step
        linkStyle3 = "activehollow";
      } else if (this.props.lateststep === 9){//loan docs
        linkStyle4 = "activehollow";
      } else if (this.props.lateststep === 13){
        linkStyle5 = "activehollow";
      }

      return (
        <div className="container padtop10 progresscontainer">
          <div className="row progressbars">
            <div className="col-xs-3" >
              <progress value={this.props.step} max={1} className="progress1" />
            </div>
            <div className="col-xs-3" >
              <progress value={this.props.infostep} max={3} className="progress2" />
            </div>
            <div className="col-xs-3" >
              <progress value={this.props.financestep} max={3} className="progress3" />
            </div>
            <div className="col-xs-3" >
              <progress value={this.props.doc} max={6} className="progress4" />
            </div>
          </div>
          <ul className="progressbar">
            <NavLink to={link1} className={linkStyle1} onClick={this.handleProgressClick}><div className="firstlink progresscircle"></div>Account</NavLink>
            <NavLink to={link2} className={linkStyle2} onClick={this.handleProgressClick}><div className={circleStyle2}></div>Info</NavLink>
            <NavLink to={link3} className={linkStyle3} onClick={this.handleProgressClick}><div className={circleStyle3}></div>Income</NavLink>
            <NavLink to={link4} className={linkStyle4} onClick={this.handleProgressClick}><div className={circleStyle4}></div>Sign</NavLink>
            <NavLink to={link5} className={linkStyle5} onClick={this.handleProgressClick}><div className={circleStyle5}></div>Approval</NavLink>
          </ul>
        </div>
      );
    }
}

const mapStateToProps = (state) => ({
    step: state.FormReducer.step,
    infostep: state.FormReducer.infostep,
    financestep: state.FormReducer.financestep,
    doc: state.FormReducer.doc,
    loggedin: state.FormReducer.loggedin,
    tooyoung: state.FormReducer.tooyoung,
    notserved: state.FormReducer.notserved,
    lateststep: state.FormReducer.lateststep,
    currentstep: state.FormReducer.currentstep
});

const mapDispatchToProps = (dispatch) => ({
    setStep: (step) => dispatch(setStep(step)),
    setInfo: (infostep) => dispatch(setInfo(infostep)),
    setFinance: (financestep) => dispatch(setFinance(financestep)),
    setDoc: (doc) => dispatch(setDoc(doc)),
    setLatest: (lateststep) => dispatch(setLatest(lateststep)),
    setCurrent: (currentstep) => dispatch(setCurrent(currentstep))
});

export default connect(mapStateToProps, mapDispatchToProps)(ProgressBar)



// WEBPACK FOOTER //
// ./src/components/partials/ProgressBar.js